module.exports = __webpack_public_path__ + "img/list-clients.0508eb90.png";